import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AgentDto, AgentFieldValidationDto, AgentProvisionFormDataDto, DocumentDto, DocumentTypeEnum, GovernmentRecordDto, GovernmentRecordLookupDto, LoginResponseDto, MsisdnDto, ResultListDto, SearchResultDocumentDto, SearchResultMsisdnDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpAgentService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/agent', authService);
	}

	public doChangePassword(payload: any): Observable<LoginResponseDto> {
		return super.doPost(true, `/self/change_password`, payload);
	}
	public doRegisterSetPassword(agent: AgentDto, jwtToken: string): Observable<LoginResponseDto> {
		return super.doPostWithAuth(`/self/register/password`, jwtToken, agent);
	}
	public doRegisterComplete(agent: AgentDto, jwtToken: string): Observable<AgentDto> {
		return super.doPostWithAuth(`/self/register/complete`, jwtToken, agent);
	}
	public doRegisterUploadPortrait(file: any, jwtToken: string): Observable<HttpEvent<AgentDto>> {
		return super.doUploadFileWithAuth(`/self/register/portrait`, jwtToken, file);
	}
	public doRegisterUploadFrontDocument(file: any, jwtToken: string): Observable<HttpEvent<AgentDto>> {
		return super.doUploadFileWithAuth(`/self/register/front_document`, jwtToken, file);
	}
	public doRegisterUploadBackDocument(file: any, jwtToken: string): Observable<HttpEvent<AgentDto>> {
		return super.doUploadFileWithAuth(`/self/register/back_document`, jwtToken, file);
	}
	public search(filter: AgentDto, pageNumber: number, pageSize: number): Observable<ResultListDto<AgentDto>> {
		return super.doPost(true, `/search?pageNumber=${pageNumber}&pageSize=${pageSize}`, filter);
	}
	public get(id: number): Observable<AgentDto>{
		return super.doGet(true, `/${id}`);
	}
	public getSelf(): Observable<AgentDto>{
		return super.doGet(true, `/self`);
	}
	public validate(field: string, value: string, agent?: AgentDto):Observable<AgentFieldValidationDto>{
		if(agent){
			return super.doPost(true, `/${agent.id}/validate/${field}`, value);
		}else{
			return super.doPost(true, `/validate/${field}`, value);
		}
	}
	public provision(input: AgentDto):Observable<AgentDto>{
		return super.doPost(true, `/provision`, input);
	}
	public editSelf(input: AgentDto):Observable<AgentDto>{
		return super.doPost(true, `/self`, input);
	}
	public editAgent(input: AgentDto):Observable<AgentDto>{
		return super.doPost(true, `/${input.id}`, input);
	}

	public getProvisionData():Observable<AgentProvisionFormDataDto>{
		return super.doGet(true, `/provision_data`);
	}
	public getGovernmentRecord(idNumber: string):Observable<GovernmentRecordLookupDto>{
		return super.doPost(true, `/lookup_government`, {
			governmentRecord:{
				idNumber: idNumber
			}
		});
	}
	public block(input:AgentDto): Observable<AgentDto>{
		return super.doPost(true, `/${input.id}/block`,{});
	}
	public unblock(input:AgentDto): Observable<AgentDto>{
		return super.doPost(true, `/${input.id}/unblock`,{});
	}
	public reset(input:AgentDto): Observable<AgentDto>{
		return super.doPost(true, `/${input.id}/reset`,{});
	}
}
